import { initialWertsachen } from '../reducer/produkte.reducer';
import { PartialProduktV18, StatePreV18, StateV18 } from './18_migrate_vhv_produkt.interface';

export const migrateVhvCheckoutProdukt = (
  previousState: StatePreV18,
  version: number,
): StateV18 => {
  return {
    ...previousState,
    version,
    produkte: previousState.produkte.map(product => {
      const updatedProduct =
        product.showWertsachenfrage != undefined
          ? {
              ...product,
              showAngabenZumHaushalt: product.showWertsachenfrage,
              wertsachenValue: undefined,
              versicherungssumme: undefined,
              showWertsachensummeQuestion: undefined,
              wertsachen: product.showWertsachenfrage ? initialWertsachen() : undefined,
              staendigBewohnt: undefined,
            } as PartialProduktV18
          : {
              ...product,
              showAngabenZumHaushalt: undefined,
              wertsachenValue: undefined,
              versicherungssumme: undefined,
              showWertsachensummeQuestion: undefined,
              wertsachen: undefined,
              staendigBewohnt: undefined,
            } as PartialProduktV18;

      if (updatedProduct.showAngabenZumHaushalt != undefined) {
        delete updatedProduct.showWertsachenfrage;
      }
      return updatedProduct;
    }),
  };
};
